import type { KatAlert } from "@amzn/katal-react";
import React from "react";
import type { Dispatch, SetStateAction } from "react";
import AlertItem from "src/components/Alert/AlertItem";
import { LogLevel, log } from "src/logger";

export interface CreateNewAlertRequest {
  readonly fade: boolean;
  readonly header?: string;
  readonly text: string;
  readonly isSuccess: boolean;
  readonly variant?: KatAlert.Variant;
  readonly alerts: React.ReactNode[];
  readonly setAlerts: Dispatch<SetStateAction<React.ReactNode[]>>;
}

interface AlertProps {
  description: string;
  header?: string;
  fade: boolean;
  variant: KatAlert.Variant;
}

export const createAlert: (props: AlertProps) => React.ReactNode = (
  props: AlertProps
) => {
  return (
    <AlertItem
      description={props.description}
      header={props.header}
      variant={props.variant}
      fade={props.fade}
    />
  );
};

export const alertHandler = {
  createNewAlertEntry: ({
    fade,
    header,
    text,
    isSuccess,
    variant,
    alerts,
    setAlerts,
  }: CreateNewAlertRequest): React.ReactNode => {
    const newAlert = createAlert({
      header,
      fade,
      description: text,
      variant: variant ?? (isSuccess ? "success" : "danger"),
    });
    setAlerts([...alerts, newAlert]);

    log({
      level: LogLevel.INFO,
      message: "Created new alert",
      operationNamespace: "alert.createNewAlertEntry",
    });

    return newAlert;
  },
};
